export default "__VITE_ASSET__DM08GUyb__"